export default __webpack_public_path__ + "static/media/spinner.bd05dd5c.gif";